import React from 'react'
import { Box, HStack, Link, VStack } from '@chakra-ui/react'

export const AppFooter = () => {
  return (
    <VStack as="footer" bottom={0} position="fixed" spacing={0} width="100%">
      <Box
        background="#1D295B"
        color="white"
        direction="row"
        fontSize="small"
        pl="5px"
        py="5px"
        width="100%"
      >
        <Link
          href="https://www.apexclearing.com/privacy-policy"
          pr="5px"
          _hover={{ color: 'white', textDecoration: 'underline' }}
        >
          Privacy Policy
        </Link>
        |
        <Link
          href="https://www.apexclearing.com/disclosures"
          px="5px"
          _hover={{ color: 'white', textDecoration: 'underline' }}
        >
          Other Disclosures
        </Link>
        |
        <Link
          href="https://www.apexclearing.com/futures-disclosures"
          pl="5px"
          _hover={{ color: 'white', textDecoration: 'underline' }}
        >
          Futures Disclosures
        </Link>
      </Box>
      <Box
        py="5px"
        fontSize="small"
        background="#F68C26"
        color="white"
        width="100%"
      >
        <HStack justify="space-between">
          <Box pl="5px" data-testid="copyright">
            © {new Date().getFullYear()} Apex Fintech Solutions
          </Box>
          <Box pr="5px" data-testid="footer-version">
            Member of FINRA, NYSE, SIPC. | v {process.env.REACT_APP_VERSION}
          </Box>
        </HStack>
      </Box>
    </VStack>
  )
}
